// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"get-app-m__wrapper__2okfG","header":"get-app-m__header__1HcBL","get-app":"get-app-m__get-app__3IA6H","item":"get-app-m__item__3IRGO","link":"get-app-m__link__1xelW"};